import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import MissionCard from '../components/MissionCard';
import { useMissionContext } from '../context/MissionContext';

function pickPreviewMissions(missions, limit = 3) {
  const open = missions.filter((m) => m.statut === 'a_venir' || m.statut === 'en_cours');
  const sorted = [...open].sort((a, b) => {
    const da = new Date(a.date_inspection || a.date_prevue || a.date_affectation || 0).getTime();
    const db = new Date(b.date_inspection || b.date_prevue || b.date_affectation || 0).getTime();
    return da - db;
  });
  return sorted.slice(0, limit);
}

export default function HomeDashboard() {
  const { stats, missions } = useMissionContext();
  const navigate = useNavigate();
  const preview = useMemo(() => pickPreviewMissions(missions, 3), [missions]);

  const goMission = (mission) => {
    navigate('/mission/' + encodeURIComponent(mission.id));
  };

  return (
    <>
      {stats && (
        <div className="stats-grid">
          <div className="stat-card stat-primary">
            <div className="stat-value">{stats.total || 0}</div>
            <div className="stat-label">Total</div>
          </div>
          <div className="stat-card stat-primary">
            <div className="stat-value">{stats.a_venir || 0}</div>
            <div className="stat-label">A venir</div>
          </div>
          <div className="stat-card stat-warning">
            <div className="stat-value">{stats.en_cours || 0}</div>
            <div className="stat-label">En cours</div>
          </div>
          <div className="stat-card stat-success">
            <div className="stat-value">{stats.completees || 0}</div>
            <div className="stat-label">Completees</div>
          </div>
        </div>
      )}

      <div className="home-quick-actions">
        <button type="button" className="home-cta home-cta--calendar" onClick={() => navigate('/calendrier')}>
          <span className="home-cta__title">Calendrier</span>
          <span className="home-cta__subtitle">Planning et creneaux</span>
        </button>
        <button type="button" className="home-cta home-cta--missions" onClick={() => navigate('/missions')}>
          <span className="home-cta__title">Missions</span>
          <span className="home-cta__subtitle">Liste complete</span>
        </button>
      </div>

      <section className="home-preview">
        <h2 className="home-preview__title">Prochaines missions</h2>
        {preview.length === 0 ? (
          <p className="home-preview__empty">Aucune mission a venir ou en cours</p>
        ) : (
          <div className="missions-list">
            {preview.map((mission) => (
              <MissionCard key={mission.id} mission={mission} onClick={goMission} />
            ))}
          </div>
        )}
      </section>
    </>
  );
}
